var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-wrapper"},[_c('app-table',{attrs:{"id":"course-lesson-table","options":_vm.options},on:{"action":_vm.triggerActions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }